import { createTheme } from '@mui/material/styles';

import { PaletteThemeProps } from '@/@mantis/types/theme';

import ThemeOption from './theme';

export default function Palette() {
  const paletteColor: PaletteThemeProps = ThemeOption();

  return createTheme({
    palette: {
      ...paletteColor,
      text: {
        primary: paletteColor.secondary.darker,
        secondary: paletteColor.secondary.dark,
        disabled: paletteColor.secondary[400],
      },
      action: {
        disabled: paletteColor.secondary.light,
      },
      divider: paletteColor.secondary[200],
      background: {
        paper: paletteColor.secondary.lighter,
        default: paletteColor.secondary[100], // main background color
      },
    },
  });
}
